export default __webpack_public_path__ + "static/media/m_engineering_card25_1.a409ee95.png";